import React, { useEffect, useState, useMemo } from 'react'
import api from '../components/api';
import { cor, corEnviado, rotulo, rotuloEnviado, sleep, corCertificado } from '../components/functions'
import { useHistory } from 'react-router-dom';
import { MDBDataTableV5 } from 'mdbreact';
import LoaderIcon from "react-loader-icon";
import ModalDesafioClima from '../modals/desafioClima'
import ModalPlanilhaGHG from '../modals/planilhaGHG'
import axios from 'axios'
import ModalValidacao from '../modals/validacao'
import ModalEmailCorrecao from '../modals/emailCorrecao'
import Pendencias from '../components/Pendencias'

import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import { useVerificaDesafioContext } from '../context/verificaDesafioContext'

import ModalEmailVer from '../modals/emailVer'
import { useEmailVerContext } from '../context/emailVerContext'


import "@fortawesome/fontawesome-free/css/all.min.css";
import Badge from 'react-bootstrap/Badge';


const Clima = () => {

    const history = useHistory()

    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()
    const { desafioEmail_id, setDesafioEmail_id } = useEmailVerContext()

    const [carregando, setCarregando] = useState('block')

    var [hospClima_id, setHospClima_id] = useState()
    var [adesao_institucional_id, setAdesaoInstitucionalId] = useState()

    var [resultado, setResultado] = useState([])
    var [resultadoRede, setResultadoRede] = useState()
    var [resultadoPend, setResultadoPend] = useState([])
    var [resultadoProc, setResultadoProc] = useState()
    var [resultadoPlan, setResultadoPlan] = useState()

    var [ano, setAno] = useState(new Date().getFullYear() -1)
    var [anoProps, setAnoProps] = useState()
    var [anos, setAnos] = useState()
    var [adesao_institucional_id_ref, setAdesaoInstitucionalIdRef] = useState(0)

    var [anoConsolidado, setAnoConsolidado] = useState(new Date().getFullYear() -1)

    var [resultadoCorrecoes, setResultadoCorrecoes] = useState([])
    var [totalCorrecoes, setTotalCorrecoes] = useState(0)
    
    var [totalPreenchimentos, setTotalPreenchimentos] = useState(0)

    const [uf, setUF] = useState('')
    const [resultadoUF, setResultadoUF] = useState([])
    const [regiao, setRegiao] = useState('')
    const [resultadoRegiao, setResultadoRegiao] = useState([])

    const [totalVerificados, setTotalVerificados] = useState(0)
    const [resultadoVerificados, setResultadoVerificados] = useState([])

    const [totalAdesoes, setTotalAdesoes] = useState(0)
    const [totalNotificacoes, setTotalNotificacoes] = useState(0)

        /*
        <div className="table-responsive">
        <table id="dataTableExample2" className="table table-bordered table-striped table-hover">
            <thead>
                <tr>
                    <th>Nome Fantasia</th>
                    <th>CNPJ</th>
                    <th><center>Último ano</center></th>
                    <th><center>Último preenchimento</center></th>
                    <th><center>Adesão em</center></th>
                    <th><center>Upload da planilha mais recente</center></th>
                    
                    
                </tr>
            </thead>
            <tbody>
                {resultado}
            </tbody>
            
        </table>

    </div>
    */



    const columnsR = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'ultimoAnoInformado',
            header: 'Último ano',
          },
          {
            accessorKey: 'dataUltimoPreenchimento',
            header: 'Último preenchimento',
          },
          {
            accessorKey: 'dataAdesao',
            header: 'Adesão em',
          },
          {
            accessorKey: 'planilhaMaisRecente',
            header: 'Upload da planilha mais recente',
          },


        ],
        [],
      );






    const columns = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'anoDesafio',
            header: 'Ano',
          },
          {
            accessorKey: 'uf_codigo',
            header: 'UF',
          },

          {
            accessorKey: 'situacaoPerfilAnual',
            header: 'Perfil Anual',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
            ),
          },


          {
            accessorKey: 'secaoAcoesLideranca',
            header: 'Ações de Liderança',
            Cell: ({ renderedCellValue, row }) => (
            
                /* 
                <span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                */
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
            ),
          },
          {
            accessorKey: 'secaoResiliencia',
            header: 'Resiliência',
            Cell: ({ renderedCellValue, row }) => (
            
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
            ),
          },

          {
            accessorKey: 'secaoDadosEmissoes',
            header: 'Dados de Emissões de GEE',
            Cell: ({ renderedCellValue, row }) => (
            
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
            ),
          },


          {
            accessorKey: 'secaoCombustaoEstacionaria',
            header: 'Combustão Estacionária',
            Cell: ({ renderedCellValue, row }) => (
            
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
            ),
          },



          {
            accessorKey: 'dataUltimoPreenchimento',
            header: 'Último preenchimento',
          },

          {
            accessorKey: 'dataAdesao',
            header: 'Adesão',
          },

          {
            accessorKey: 'situacaoEnviado',
            header: 'Situação',
            Cell: ({ renderedCellValue, row }) => (
            
                /*
                renderedCellValue == 'S' ? '#7edeed' : renderedCellValue == 'V' ? '#59d970' : renderedCellValue == 'A' ? '#c1de64' : renderedCellValue == 'P' ? '##fa745c' : renderedCellValue == 'E' ? 
                <span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'A' ? 'warning' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : renderedCellValue == null || renderedCellValue == 'P' ? 'primary' : 'warning' }`}>{rotuloEnviado(renderedCellValue)}</span>
                */
                <Badge style={{  backgroundColor: corEnviado(renderedCellValue) }}>{rotuloEnviado(renderedCellValue)}</Badge>
            ),
          },


          {
            accessorKey: 'dataEnvio',
            header: 'Enviado em',
          },
         

          {
            accessorKey: 'dataHoraUltimaAuditoria',
            header: 'Última auditoria em',
          },
         




        ],
        [],
      );


    
      const columnsCorrecoes = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'anoDesafio',
            header: 'Ano',
          },

          {
            accessorKey: 'situacaoPerfilAnual',
            header: 'Perfil Anual',
            Cell: ({ renderedCellValue, row }) => (
            
                <span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
           
            ),
          },

          {
            accessorKey: 'secaoAcoesLideranca',
            header: 'Ações de Liderança',
            Cell: ({ renderedCellValue, row }) => (
            
                <span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
           
            ),
          },
          {
            accessorKey: 'secaoResiliencia',
            header: 'Resiliência',
            Cell: ({ renderedCellValue, row }) => (
            
                <span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
           
            ),
          },

          {
            accessorKey: 'secaoDadosEmissoes',
            header: 'Dados de Emissões de GEE',
            Cell: ({ renderedCellValue, row }) => (
            
                <span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
           
            ),
          },

          {
            accessorKey: 'secaoMeta',
            header: 'Metas',
            Cell: ({ renderedCellValue, row }) => (
            
                <span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
           
            ),
          },


          {
            accessorKey: 'situacaoEnviado',
            header: 'Situação',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'A' ? 'warning' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotuloEnviado(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: renderedCellValue == 'P' ? '#ffc4ab' : renderedCellValue == 'S' || renderedCellValue == null  ? '#7edeed' : renderedCellValue == 'A' ? '#ebe7b2' : renderedCellValue == 'V' ? '#59d970' : '#003366'  }}>{rotuloEnviado(renderedCellValue)}</Badge>
           
            ),
          },


         

        ],
        [],
      );


      const columnsVerificados = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'anoDesafio',
            header: 'Ano',
          },

          {
            accessorKey: 'certificacao',
            header: 'Reconhecimento',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: corCertificado(renderedCellValue) }}>{renderedCellValue}</Badge>
           
            ),
          },
         

        ],
        [],
      );


    async function processamentoGHG() {


        var headers = {

            'Content-type': 'application/json',
            'x-access-token': '!nf0$@ud#2'

        }

        axios.get('https://api3.hospitaissaudaveis.org/verificaLista', { headers: headers }).then((result) => {

            //console.log(result.data)

            setResultadoProc(result.data.map((rs) => {

                return {

                    dataFila: rs.ad_new,
                    nome_fantasia: rs.nome_fantasia,
                    status: rs.status == 'P' ? 'Processamento pendente' : rs.status == 'F' ? 'Processamento finalizado' : rs.status == 'A' ? 'Aguardando processamento' : rs.status == 'E' ? 'Erro ao processar arquivo' : '',
                    cnpj: rs.cnpj,
                    ano: rs.ano,
                }


            }))

        }).catch((err) => {

            console.log(err.response)

        })



    }




    const dataProcessamento = {


        columns: [


            {
                label: 'Data',
                field: 'dataFila',
                sort: 'desc',
                width: 100
              },

            {
                label: 'Nome Fantasia',
                field: 'nome_fantasia',
                sort: 'asc',
                width: 270
              },
              {
                label: 'CNPJ',
                field: 'cnpj',
                sort: 'asc',
                width: 200
              },
              {
                label: 'Ano',
                field: 'ano',
                sort: 'asc',
                width: 100
              },

              {
                label: 'Processamento planilha',
                field: 'status',
                sort: 'asc',
                width: 100
              },

              

        ],

        rows: resultadoProc


    }


    const dataPlan = {


        columns: [

          
          
            {
              label: 'Nome Fantasia',
              field: 'nome_fantasia',
              sort: 'asc',
              width: 270
            },
            {
              label: 'CNPJ',
              field: 'cnpj',
              sort: 'asc',
              width: 200
            },
            
          
            {
              label: 'Ano',
              field: 'ano',
              sort: 'asc',
              width: 100
            },
            
            {
              label: 'Processado em',
              field: 'ad_new',
              sort: 'asc',
              width: 100
            },
  
          ],

        rows: resultadoPlan
    
    }


    async function carregaRede() {

        await api.get(`adesaoInstitucionalRede`).then((result) => {

            setResultadoRede(result.data.map((rs) =>

                <option value={rs.adesao_institucional_id} key={rs.adesao_institucional_id}>{rs.razao_social}</option>
            
            ))

        })

    }



    async function carregaAnos() {

        var anoTemp = []

        var anoAtual = new Date().getFullYear()

        for (var x = anoAtual; x >= 2008; x--) {

            var anoJson = {

                ano: x,

            }

            anoTemp.push(anoJson)

        }

        setAnos(anoTemp.map((rs) =>
        
            <option value={rs.ano}>{rs.ano}</option>
        
        ))

    }




    async function desafioClimaLista() {

        await api.get('desafioClimaLista').then((result) => {
            
            setTotalAdesoes(result.data.length)
            setResultado(result.data)

            /*
            
            setResultado(result.data.map((rs) => 

                <tr style={{ cursor: 'pointer' }} onClick={() => history.push(`/DesafioClima/${rs.adesao_institucional_id}`)}>
                    <td>
                        {rs.nome_fantasia}
                    </td>
                    <td>
                        {rs.cnpj}
                    </td>
                    <td>
                        <center>
                        {rs.ultimoAnoInformado}
                        </center>
                    </td>
                    <td>
                        <center>
                        {rs.dataUltimoPreenchimento}
                        </center>
                    </td>
                    <td>
                        <center>
                        {rs.dataAdesao}
                        </center>
                    </td>
                    <td>
                        <center>
                        {rs.planilhaMaisRecente}
                        </center>
                    </td>
                   
                </tr>

            ))

            dataTableRender('dataTableExample2', 0, 'asc')

            */




        }).catch((err) => {
            console.log(err.response)
        })

    }


    /*
    async function geraExcel() {

        //return false

        window.toastr.info('Aguarde, gerando XLSX...')

        await api.get('desafioClimaListaXLS').then((result) => {

            if (result.data.alerta == 'ok') {

                sleep(1000).then(() => {

                    window.location.href = `${process.env.REACT_APP_API}/${result.data.arquivo}`
                    //window.location.href = `http://172.16.1.253:3600/${result.data.arquivo}`

                })
                

            }

        }).catch((err) => {

            console.log(err.response)

        })

    }
    */
    const geraExcel = async () => {

        window.toastr.info("Aguarde...");

        try {

        const response = await api.get("desafioClimaListaXLS", {
            responseType: "blob",
            validateStatus: (status) => true // para não cair direto no catch
        });

        if (response.status !== 200) {
            // ler como texto para ver o erro real
            const errorText = await response.data.text();
            console.error("Erro backend:", errorText);
            window.toastr.error("Erro ao exportar: " + errorText);
            return;
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "adesaoClima.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        window.toastr.success("Download concluído!");
        } catch (err) {
        console.error(err);
        window.toastr.error("Falha ao baixar arquivo");
        }
    };



    async function geraExcelProc() {


        window.toastr.info('Aguarde, gerando XLSX...')

        await api.get(`exportaXls/0/${anoConsolidado}`).then((result) => {

            //console.log(result.data)
            //return false

            if (result.data.alerta == 'ok') {

                sleep(1000).then(() => {

                    //window.location.href = `https://api.hospitaissaudaveis.org/${result.data.arquivo}`
                    //window.location.href = `http://172.16.1.253:3600/${result.data.arquivo}`
                    window.location.href = result.data.arquivo

                })
                

            }

        }).catch((err) => {

            console.log(err.response)

        })



    }


    


    async function preenchimentos(adesao_institucional_id_ref) {

        if (adesao_institucional_id_ref == null) { adesao_institucional_id_ref = 0 }


        var dataPost = {

            regiao: regiao,
            uf: uf,

        }

        setCarregando('block')

        await api.post(`desafioClimaListaPendencias/${adesao_institucional_id_ref}/${ano}`, dataPost).then((result) => {

            //console.log(result.data)

            setTotalPreenchimentos(result.data.length)

            setResultadoPend(result.data)
            /*
            setResultadoPend(result.data.map((rs) => {

                return {

                    nome_fantasia: rs.nome_fantasia,
                    cnpj: rs.cnpj,
                    hospClima_id: rs.hospClima_id,
                    situacaoPerfilAnual: rotulo(rs.situacaoPerfilAnual),
                    secaoAcoesLideranca: rotulo(rs.secaoAcoesLideranca),
                    secaoDadosEmissoes: rotulo(rs.secaoDadosEmissoes),
                    dataEnvio: rs.dataEnvio,
                    situacaoEnviado: rotuloEnviado(rs.situacaoEnviado),
                    dataEnvio: rs.dataEnvio,
                    dataUltimoPreenchimento: rs.dataUltimoPreenchimento,
                    anoDesafio: rs.anoDesafio,
                    dataAdesao: rs.dataAdesao,
                    anoPerfil: rs.anoPerfil,
                    anoDesafio: rs.anoDesafio,
                    adesao_institucional_id: rs.adesao_institucional_id,
                    clickEvent: () => { setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio); setAdesaoInstitucionalId(rs.adesao_institucional_id); setHospClima_id(rs.hospClima_id); window.$("#modalDesafioClima").modal('show');}
                    
                }

            }))
            */

            setCarregando('none')
            

        }).catch((err) => {

            console.log(err)
            setCarregando('none')

        })


    }

    /*
    async function geraExcelPend() {

        window.toastr.success('Aguarde, gerando XLSX...')

        await api.get(`geraExcelDesafioClimaPend/${adesao_institucional_id_ref}/${ano}`).then((result) => {

            if (result.data.alerta == 'ok') {

                sleep(1000).then(() => {

                    //window.location.href = `http://apihomolog.hospitaissaudaveis.org/residuosSS.xlsx`
                    window.location.href = `${process.env.REACT_APP_API}/${result.data.arquivo}`

                })
                
            }

        }).catch((err) => {

            console.log(err.response)

        })

    }
    */


    const geraExcelPend = async () => {

        window.toastr.info("Aguarde...");

        try {

        const response = await api.get(`geraExcelDesafioClimaPend/${adesao_institucional_id_ref}/${ano}`, {
            responseType: "blob",
            validateStatus: (status) => true // para não cair direto no catch
        });

        if (response.status !== 200) {
            // ler como texto para ver o erro real
            const errorText = await response.data.text();
            console.error("Erro backend:", errorText);
            window.toastr.error("Erro ao exportar: " + errorText);
            return;
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "clima.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        window.toastr.success("Download concluído!");
        } catch (err) {
        console.error(err);
        window.toastr.error("Falha ao baixar arquivo");
        }
    };






    async function planilhasGHG() {

        api.get(`GHG_Proc`).then((result) => {

            console.log(result.data)

            setResultadoPlan(result.data.map((rs) => {

                /*

                ad_new:         "28/12/2022 16:12:02"
        adesao_institucional_id        : 
        3
        ano
        : 
        "2021"
        arquivo
        : 
        "61590410000124_2021_DesafioClima.xlsx"
        cnpj
        : 
        "61590410000124"
        nome_fantasia
        : 
        "HOSPITAL SÍRIO LIBANÊS"
        razao_social
        : 
        "SOCIEDADE BENEFICIENTE DE SENHORAS HOSPITAL SÍRIO LIBANÊS"
        status
        : 
        "F"

        */

                return {

                    nome_fantasia: rs.nome_fantasia,
                    cnpj: rs.cnpj,
                    ano: rs.ano,
                    ad_new: rs.ad_new,
                    clickEvent: () => { setAno(rs.ano); setAdesaoInstitucionalId(rs.adesao_institucional_id); window.$("#modalPlanilhaGHG").modal('show');}
                    
                    
                }

            }))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    const carregaRegiao = () => {

        api.get('regiao').then((result) => {

            setResultadoRegiao(result.data.map((rs) =>
                    
                <option value={rs.regiao}>{rs.regiao}</option>
        
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    const carregaUF = () => {

        api.get('uf').then((result) => {

            //console.log(result.data)

            setResultadoUF(result.data.map((rs) =>
                    
                <option value={rs.uf_codigo}>{rs.uf_codigo}</option>
        
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    useEffect(() => {

        carregaRede()
        carregaUF()
        carregaAnos()
        carregaRegiao()
        desafioClimaLista()

    }, [])



    const correcoes = () => {

        var dataPost = {

            desafio: 'Clima'

        }

        api.post('desafioValidaCorrecoes', dataPost).then((result) => {

            //console.log(result.data, 'correcoes')

            setResultadoCorrecoes(result.data)
            setTotalCorrecoes(result.data.length)

        }).catch((err) => {

            console.log(err.response)

        })


    }



    const verificados = () => {

        var dataPost = {

            desafio: 'Clima'

        }

        api.post('desafioValidaVerificados', dataPost).then((result) => {

            //console.log(result.data, 'verificados')

            setResultadoVerificados(result.data)
            setTotalVerificados(result.data.length)

        }).catch((err) => {

            console.log(err.response)

        })


    }


    const abreCertificado = async (dataPost) => {

        

        api.post('certificado', dataPost).then((result) => {

            window.toastr.info('Aguarde...')
            
            if (result.data.arquivo) {

                sleep(1000).then(() => {

                    window.open(`${process.env.REACT_APP_API}/pdf/${result.data.arquivo}`)
                    

                })

            }

        }).catch((err) => {

            console.log(err.response)

        })

    }


    useEffect(() => {

        //console.log(ano)
        preenchimentos(adesao_institucional_id_ref)
        correcoes()
        verificados()

    }, [ano, uf, regiao, verificaDesafio])



    return (

        <div>
             <div className='content-header'>
                <div className='header-icon'>
                    <i className='pe-7s-umbrella'></i>
                </div>
                <div className='header-title'>
                    <h1>Desafio Clima</h1>
                    <small>Administração</small>
                    
                </div>
            </div>

            <ul className="nav nav-tabs">
                <li  ><a href="#tab1" data-toggle="tab">Adesões ({totalAdesoes})</a></li>
                <li className="active"><a href="#tab2" data-toggle="tab" onClick={() => {} } >Preenchimentos ({totalPreenchimentos})</a></li>
                <li ><a href="#tab5" data-toggle="tab">Correções ({totalCorrecoes})</a></li>
                <li ><a href="#tab6" data-toggle="tab">Verificados ({totalVerificados})</a></li>
                <li style={{ display: 'none'}} ><a href="#tab3" data-toggle="tab" onClick={() => processamentoGHG() } >Processamento</a></li>
                <li style={{ display: 'none'}} ><a href="#tab4" data-toggle="tab" onClick={() => planilhasGHG() } >Planilhas processadas</a></li>
                <li ><a href="#tab7" data-toggle="tab">Notificações ({totalNotificacoes})</a></li>


                
                
            </ul>

            <div class="tab-content">
                <div class="tab-pane fade in " id="tab1">
                    <div class="panel-body">


                        <div class="col-md-12">


                            <button type="button" class="btn btn-success" onClick={() => geraExcel()}>Exportar XLS</button>&nbsp;
                            <br/><br/>


                            </div>


                            <div className="row">
                                <div className="col-sm-12"  style={{ display: resultado ? 'block' : 'none'}}>

                                <MaterialReactTable 

                                    columns={columnsR} 
                                    data={resultado} 
                                    localization={MRT_Localization_PT_BR}
                                    //rowsPerPage={20}
                                    //options={options}
                                    initialState={{ density: 'compact' }}
                                    muiTableHeadCellProps={{
                                        //easier way to create media queries, no useMediaQuery hook needed.
                                        sx: {
                                        fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                        },
                                        },
                                    }}
                                    muiTableBodyCellProps={{
                                        sx: {
                                            fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                            },
                                        },
                                    }}
                                    muiTableBodyRowProps={({ row }) => ({
                                    onClick: (event) => {
                                        //console.info(event, row.original.usuario_id);
                                        history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                        //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                        //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                        //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                        //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setHospClima_id(row.original.hospClima_id); window.$("#modalDesafioClima").modal('show')

                                    },
                                    sx: {
                                        cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                    },
                                    })}
                                    />
                                    
                                            
                                    

                                </div>
                            </div>


                        </div>

                    </div>
                    <div className="tab-pane fade in" id="tab7">

                        <Pendencias
                            desafio="Clima"
                            setTotalNotificacoes={setTotalNotificacoes}
                            abrirModal={(item) => {

                                setAdesaoInstitucionalId(
                                    item.adesao_institucional_id
                                )

                                setHospClima_id(
                                    item.hospClima_id ??
                                    item.formulario_id
                                )

                                setAnoProps(
                                    item.anoPerfil ??
                                    item.anoDesafio ??
                                    item.ano
                                )

                                window.$(
                                    '#modalDesafioClima'
                                ).modal('show')

                            }}
                        />

                    </div>
                
                    <div className="tab-pane fade in active" id="tab2">
                    
                        <div className="panel-body">

                            <div className="col-md-12">


                                <button type="button" className="btn btn-success" onClick={() => geraExcelPend()}>Exportar XLS</button>&nbsp;
                                <br/>


                            </div>

                            <div className="col-md-12">

                                <div className="form-group">

                                    <br/>
                                    
                                    <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {preenchimentos(event.target.value);setAdesaoInstitucionalIdRef(event.target.value)}} value={adesao_institucional_id_ref} >
                                        <option value="0">[Rede ou Sistema de Saúde]</option>
                                        {resultadoRede}
                                    </select>  
                                    
                                </div>
                            
                            </div>

                            <div className="col-md-4">
                                <div className="form-group">

                                    
                                    
                                    <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setAno(event.target.value)}} value={ano} >
                                        <option value={0}>Todos os anos</option>
                                        {anos}
                                    </select>  
                                    
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">

                                    
                                    <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setUF(event.target.value)}} value={uf} >
                                        <option value="">[UF]</option>
                                        {resultadoUF}
                                    </select>  
                                    
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">

                                    
                                    <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setRegiao(event.target.value)}} value={regiao} >
                                        <option value="">[Região]</option>
                                        {resultadoRegiao}
                                    </select>  
                                    
                                </div>
                            </div>

                            <div className="col-md-12" style={{ display: carregando }} >
                            <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                            </div>

                            <div className="col-md-12" style={{ display: carregando == 'none' ? 'block' : 'none'}}>


                                <MaterialReactTable 

                                columns={columns} 
                                data={resultadoPend} 
                                localization={MRT_Localization_PT_BR}
                                //rowsPerPage={20}
                                //options={options}
                                initialState={{ density: 'compact' }}
                                muiTableHeadCellProps={{
                                    //easier way to create media queries, no useMediaQuery hook needed.
                                    sx: {
                                    fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                    },
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                        },
                                    },
                                }}
                                muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {
                                    //console.info(event, row.original.usuario_id);
                                    //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                                    //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                    //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                    //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                    setAnoProps(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setHospClima_id(row.original.hospClima_id); window.$("#modalDesafioClima").modal('show')

                                },
                                sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                },
                                })}
                                />

                            </div>


                        </div>

                    </div>

                    <div className="tab-pane fade in" id="tab5">


                        <div className="col-md-12" style={{ display: carregando }} >
                            <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                        </div>
                    
                        <div className="col-md-12" style={{ display: resultadoCorrecoes ? 'block' : 'none'}}>


                            <MaterialReactTable 

                                columns={columnsCorrecoes} 
                                data={resultadoCorrecoes} 
                                localization={MRT_Localization_PT_BR}
                                //rowsPerPage={20}
                                //options={options}
                                initialState={{ density: 'compact' }}
                                muiTableHeadCellProps={{
                                    //easier way to create media queries, no useMediaQuery hook needed.
                                    sx: {
                                    fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                    },
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                        },
                                    },
                                }}
                                muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {
                                    //console.info(event, row.original.usuario_id);
                                    //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                                    //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                    //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                    //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                    setAnoProps(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setHospClima_id(row.original.hospClima_id); window.$("#modalDesafioClima").modal('show')

                                },
                                sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                },
                                })}
                                />


                        </div>


                    </div>

                    <div className="tab-pane fade in" id="tab6">

                        <div className="panel-body">

                                <div className="col-md-12" style={{ display: carregando }} >
                                  <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                                </div>
                            
                              <div className="col-md-12" style={{ display: resultadoVerificados ? 'block' : 'none'}}>

                                <MaterialReactTable 

                                    columns={columnsVerificados} 
                                    data={resultadoVerificados} 
                                    localization={MRT_Localization_PT_BR}
                                    //rowsPerPage={20}
                                    //options={options}
                                    initialState={{ density: 'compact' }}
                                    muiTableHeadCellProps={{
                                        //easier way to create media queries, no useMediaQuery hook needed.
                                        sx: {
                                        fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                        },
                                        },
                                    }}
                                    muiTableBodyCellProps={{
                                        sx: {
                                            fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                            },
                                        },
                                    }}
                                    muiTableBodyRowProps={({ row }) => ({
                                    onClick: (event) => {
                                        
                                        //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); 
                                        //setHospClima_id(row.original.hospClima_id); window.$("#modalCertificado").modal('show')

                                        abreCertificado({

                                            ano: row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio,
                                            adesao_institucional_id: row.original.adesao_institucional_id,
                                            formulario_id: row.original.hospClima_id,
                                            certificacao: row.original.certificacao,
                                            origem: 'Clima',

                                        })

                                    },
                                    sx: {
                                        cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                    },
                                    })}

                                />


                            </div>

                        </div>

                    </div>

                    <div className="tab-pane fade in" id="tab3">


                        <div className="panel-body">

                            <div className="col-md-12">


                            <MDBDataTableV5 

                                striped
                                bordered
                                small
                                data={dataProcessamento}
                                pagingTop
                                searchTop
                                searchBottom={false}
                                infoLabel={["Exibindo", "de", "de", "registros"]}
                                noRecordsFoundLabel={['Nenhum registro encontrado']}                    
                                searchLabel="Busca"
                                paginationLabel={["Anterior", "Próxima"]}
                                entriesLabel="Registros por página"
                                displayEntries={false}
                                responsive
                                autoWidth
                                fixed
                                barReverse
                                order={['dataUltimoPreenchimento', 'desc']}
                                exportToCSV={true}

                                />


                            </div>

                        </div>


                    </div>

                    <div className="tab-pane fade in" id="tab4">


                            


                            


                        <div className="panel-body">

                            <div className="col-md-2">

                            <button type="button" class="btn btn-success" onClick={() => geraExcelProc()}>Exportar XLS</button>&nbsp;

                            </div>

                            <div className="col-md-10">
                                <div className="form-group">
                                    
                                    <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setAnoConsolidado(event.target.value)}} value={anoConsolidado} >
                                        {anos}
                                    </select>  
                                    
                                </div>
                            </div>
                            <div className="col-md-12">


                            <MDBDataTableV5 style={{ cursor: 'pointer'}}

                                striped
                                bordered
                                small
                                data={dataPlan}
                                pagingTop
                                searchTop
                                searchBottom={false}
                                infoLabel={["Exibindo", "de", "de", "registros"]}
                                noRecordsFoundLabel={['Nenhum registro encontrado']}                    
                                searchLabel="Busca"
                                paginationLabel={["Anterior", "Próxima"]}
                                entriesLabel="Registros por página"
                                displayEntries={false}
                                responsive
                                autoWidth
                                fixed
                                barReverse
                                order={['dataUltimoPreenchimento', 'desc']}
                                exportToCSV={true}

                                />

                            </div>

                        </div>


                    </div>

                </div>

                
                <ModalDesafioClima hospClima_id={hospClima_id} formulario_id={hospClima_id} origem='Clima' ano={anoProps} adesao_institucional_id={adesao_institucional_id} />
                <ModalPlanilhaGHG ano={anoProps} formulario_id={hospClima_id} origem='Clima' adesao_institucional_id={adesao_institucional_id} />

                <ModalValidacao adesao_institucional_id={adesao_institucional_id} ano={anoProps} formulario_id={hospClima_id} origem='Clima' correcoes={correcoes} />
                <ModalEmailCorrecao adesao_institucional_id={adesao_institucional_id} ano={anoProps} formulario_id={hospClima_id} origem='Clima' correcoes={correcoes} />
                <ModalEmailVer desafioEmail_id={desafioEmail_id}  />

                


            </div>

        

    )

}

export default Clima